import { render, staticRenderFns } from "./FiltroFatura.vue?vue&type=template&id=6cdb4556&scoped=true&"
import script from "./FiltroFatura.vue?vue&type=script&lang=js&"
export * from "./FiltroFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdb4556",
  null
  
)

export default component.exports